import WebApp from '@twa-dev/sdk'

let backButtonHandler: (() => void) | null = null

const getTelegramWebApp = () => {
  const tgWindow = window as Window & { Telegram?: { WebApp?: unknown } }
  if (typeof window === 'undefined' || !tgWindow.Telegram?.WebApp) return null
  return WebApp
}

const updateViewportHeightVar = () => {
  const tg = getTelegramWebApp()
  const height = tg?.viewportStableHeight || tg?.viewportHeight || window.innerHeight
  document.documentElement.style.setProperty('--tg-viewport-height', `${height}px`)
}

export function initTelegramWebApp(): void {
  document.documentElement.style.overscrollBehavior = 'none'
  document.documentElement.style.height = '100%'
  document.body.style.margin = '0'
  document.body.style.height = '100%'
  document.body.style.overscrollBehavior = 'none'
  document.body.style.touchAction = 'none'
  document.body.style.setProperty('-webkit-overflow-scrolling', 'auto')

  updateViewportHeightVar()

  const tg = getTelegramWebApp()
  if (!tg) return

  tg.ready()
  tg.expand()
  tg.enableClosingConfirmation()
  tg.setHeaderColor('#0f172a')
  tg.setBackgroundColor('#0f172a')
  tg.onEvent('viewportChanged', updateViewportHeightVar)

  const orientation = screen.orientation as ScreenOrientation & { lock?: (orientation: string) => Promise<void> }
  if (orientation.lock) {
    orientation.lock('portrait').catch(() => undefined)
  }
}

export function setTelegramBackButton(onBack: (() => void) | null): void {
  const tg = getTelegramWebApp()
  if (!tg) return

  if (backButtonHandler) {
    tg.BackButton.offClick(backButtonHandler)
    backButtonHandler = null
  }

  if (!onBack) {
    tg.BackButton.hide()
    return
  }

  backButtonHandler = onBack
  tg.BackButton.show()
  tg.BackButton.onClick(backButtonHandler)
}

export function hapticImpactLight(): void {
  const tg = getTelegramWebApp()
  if (!tg) return
  tg.HapticFeedback.impactOccurred('light')
}

export function hapticSuccess(): void {
  const tg = getTelegramWebApp()
  if (!tg) return
  tg.HapticFeedback.notificationOccurred('success')
}

export function hapticError(): void {
  const tg = getTelegramWebApp()
  if (!tg) return
  tg.HapticFeedback.notificationOccurred('error')
}

export function shareRunScore(message: string): void {
  const tg = getTelegramWebApp()
  const targetUrl = window.location.href
  const shareUrl = `https://t.me/share/url?url=${encodeURIComponent(targetUrl)}&text=${encodeURIComponent(message)}`

  if (!tg) {
    window.open(shareUrl, '_blank', 'noopener,noreferrer')
    return
  }

  tg.openTelegramLink(shareUrl)
}
